export function publicProfileToDisplayName(profile){
  return profile?.displayName || profile?.username || 'Unknown User'
}

export function publicProfileToPathname(profile){
  const username = profile?.username
  const asMemberOf = profile?.asMemberOf
  if (username) return asMemberOf
    ? `/${asMemberOf}/members/@${username}`
    : `/@${username}`
}
